export default "__VITE_ASSET__COtlnnA8__"